import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#111827',
      light: '#374151',
      dark: '#0b1220',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#6B7280',
      light: '#9CA3AF',
      dark: '#374151',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: '#111827',
      secondary: '#6B7280',
    },
    divider: '#E5E7EB',
    action: {
      hover: 'rgba(17, 24, 39, 0.04)',
      selected: 'rgba(17, 24, 39, 0.06)',
      disabledBackground: '#F3F4F6',
      focus: 'rgba(17, 24, 39, 0.12)'
    }
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: 'Inter, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    fontWeightBold: 700,
    h1: { fontWeight: 700, fontSize: '2.2rem' },
    h2: { fontWeight: 700, fontSize: '1.8rem' },
    h3: { fontWeight: 600, fontSize: '1.4rem' },
    h4: { fontWeight: 600, fontSize: '1.1rem' },
    h5: { fontWeight: 600, fontSize: '1rem' },
    h6: { fontWeight: 600, fontSize: '0.95rem' },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: 0.2,
    },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          background: '#ffffff',
          color: '#111827',
          minHeight: '100vh',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          boxShadow: 'none',
          borderRadius: 8,
          border: '1px solid #E5E7EB',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: 'none',
          backgroundColor: '#ffffff',
          border: '1px solid #E5E7EB',
          transition: 'border-color 0.2s, transform 0.1s',
          '&:hover': {
            borderColor: '#D1D5DB',
          },
          '&:active': {
            transform: 'translateY(1px)'
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          fontWeight: 600,
          boxShadow: 'none',
          padding: '7px 18px',
          fontSize: '1rem',
          '&:hover': {
            boxShadow: 'none',
          },
          '&:focus-visible': {
            outline: '2px solid #9CA3AF',
            outlineOffset: 2,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          color: '#111827',
          boxShadow: 'none',
          borderBottom: '1px solid #E5E7EB',
          borderRadius: 0,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#ffffff',
          boxShadow: 'none',
          borderRight: '1px solid #E5E7EB',
          borderRadius: 0,
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          marginBottom: 2,
          transition: 'background 0.2s, border 0.2s',
          border: '1px solid transparent',
          color: '#111827',
          '&.Mui-selected, &.Mui-selected:hover': {
            background: 'rgba(17, 24, 39, 0.06)',
            color: '#111827',
            border: '1px solid #E5E7EB',
          },
          '&:hover': {
            background: 'rgba(17, 24, 39, 0.04)',
            border: '1px solid #E5E7EB',
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          backgroundColor: '#ffffff',
          color: '#111827',
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          borderRadius: 6,
          fontSize: '0.875rem',
          backgroundColor: '#111827',
          color: '#ffffff',
          boxShadow: 'none',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 2,
          borderRadius: 2,
          backgroundColor: '#111827',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: '#6B7280',
          '&.Mui-selected': {
            color: '#111827',
          },
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: '#E5E7EB',
        }
      }
    }
  },
});

export default theme;
